import { Model } from '@vuex-orm/core'

export default class Questionnaire extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'questionnaires'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      questionform_id: this.attr(null),
      placement_id: this.attr(null),
      candidate_id: this.attr(null),
      type: this.attr(null),
      key: this.attr(null),
      personality_meta: this.attr(null),
      used_time: this.attr(null),
      time_limit: this.attr(null),
      score: this.attr(null),
      start_at: this.attr(null),
      end_at: this.attr(null),
      questions: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Questionnaire.js